import sassVariables from '../../_variables.scss';

const variables = {
  ...sassVariables,
};

export default variables;
